import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper, List, ListItem, ListItemText, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3)
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  list: {
    padding: 0
  },
  insightItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 0)
  },
  insightText: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  insightIcon: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(0.5)
  },
  themes: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  themeChip: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText
  }
}));

const InsightsSection = ({ content, themes }) => {
  const classes = useStyles();

  if (!content || content.length === 0) {
    return null;
  }

  return (
    <Paper className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        <EmojiObjectsIcon />
        Actionable Insights
      </Typography>
      <Box className={classes.content}>
        <List className={classes.list}>
          {content.map((insight, index) => (
            <ListItem key={index} className={classes.insightItem}>
              <Box className={classes.insightText}>
                <EmojiObjectsIcon className={classes.insightIcon} />
                <ListItemText primary={insight} />
              </Box>
              {themes.length > 0 && (
                <Box className={classes.themes}>
                  {themes.map((theme, themeIndex) => (
                    <Chip
                      key={themeIndex}
                      label={theme}
                      size="small"
                      className={classes.themeChip}
                    />
                  ))}
                </Box>
              )}
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );
};

InsightsSection.propTypes = {
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
  themes: PropTypes.arrayOf(PropTypes.string)
};

InsightsSection.defaultProps = {
  themes: []
};

export default InsightsSection; 